import { render, staticRenderFns } from "./PensionOrderForm.vue?vue&type=template&id=723f585d&"
import script from "./PensionOrderForm.vue?vue&type=script&lang=ts&"
export * from "./PensionOrderForm.vue?vue&type=script&lang=ts&"
import style0 from "./PensionOrderForm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports